/**
 * Analytics Configuration for Micasa Sucasa
 * Contains all tracking IDs and tokens for GTM, GA4, and Meta Pixel
 */

export const analyticsConfig = {
  // Google Tag Manager
  gtm: {
    id: process.env.REACT_APP_GTM_ID || 'GTM-M7GRNPQ6'
  },
  
  // Google Analytics 4
  ga4: {
    measurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-M00WF1241N',
    apiSecret: process.env.REACT_APP_GA4_API_SECRET || 'kUrT2z2LRyavBWnl9eTVYA'
  },
  
  // Meta Pixel (Facebook)
  metaPixel: {
    pixelId: process.env.REACT_APP_META_PIXEL_ID || '1786280248756552',
    capiAccessToken: process.env.REACT_APP_META_CAPI_ACCESS_TOKEN || 'EAAUQjX4dC3QBQVY76mmQZAxQSYMnltmoB5mUrcYwlvVyZBdNrOgt4ZAZAGW4HVcl8udICYMEFSiRK9uzEVNQRofEjo5i78tthpSgxJ6wSPanZATGZCOSqedhpdjwMg4CuaIesVcZCevcNEP3mcOFFHKMBZA6hXj3VixXg869O8bZCJi878DoT1BYjZBcCwWmbdRwZDZD'
  }
};

// Initialize Meta Pixel
export const initializeMetaPixel = () => {
  if (typeof window !== 'undefined' && !window.fbq) {
    /* eslint-disable no-unused-expressions */
    !(function(f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    );
    /* eslint-enable no-unused-expressions */
    
    window.fbq('init', analyticsConfig.metaPixel.pixelId);
    window.fbq('track', 'PageView');
    
    console.log('[Meta Pixel] Initialized with ID:', analyticsConfig.metaPixel.pixelId);
  }
};

// Initialize GA4 (gtag)
export const initializeGA4 = () => {
  if (typeof window !== 'undefined' && !window.gtag) {
    // Add gtag script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsConfig.ga4.measurementId}`;
    script.async = true;
    document.head.appendChild(script);
    
    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', analyticsConfig.ga4.measurementId);
    
    console.log('[GA4] Initialized with ID:', analyticsConfig.ga4.measurementId);
  }
};

export default analyticsConfig;

